<template lang="html">

  <div class="toggle" :show="show" @click="toggleValue" :disabled="disabled">
    <div class="toggle-el" :style="ownstyles.toggle_el" :disabled="disabled">
      <input type="checkbox" v-model="value" @change="emitValue" :id="label" :name="(!!name) ? name : label" :disabled="disabled">
      <label :style="ownstyles.label" :active="value" :for="label" :disabled="disabled"></label>
    </div>
    <strong>{{label}}</strong><span v-if="show_result != false">: {{(value) ? 'Sí' : 'No'}}</span>
  </div>



  </template>

  <script lang="js">

    import {mapGetters} from 'vuex';

    export default  {
      name: 'toggle',
      props: ['label','dataServer','show','show_result','name','disabled'],
      mounted(){
        this.value = this.dataServer;
      },
      methods : {
        emitValue : function(){
          this.$emit('input', this.value);
          this.$emit('change', this.value);
        },
        toggleValue : function(){
          if(!!this.show && !!!this.disabled){
            this.value = !this.value;
            this.emitValue();
          }
        }
      },
      data() {
        return {
          value : false
        }
      },
      watch : {
        'show' : function(){
          this.value = this.dataServer;  
        },
        'dataServer'(){
          this.value = this.dataServer;
        }
      },
      computed : {
        ...mapGetters({
          colors : 'basicColors'        
        }),
        ownstyles : function(){
          return {
            toggle_el : {
              background : this.colors.soft_black
            },
            label : {
              background : (this.value) ? '#00913d' : this.colors.medium_black
            }
          }
        }
      }
    }
  </script>

  <style scoped lang="scss">

  .toggle{
    position: relative;
    transition: .5s;
    overflow: hidden;
    cursor: pointer;
    text-align: left;
    max-width: max-content;
    display: flex;
    &[disabled=disabled]{
      /* pointer-events: none; */
      cursor:not-allowed;
    }
  }

  .toggle[show=true]{
    padding-left: 40px;
  }

  .toggle-el{
    width: 30px;
    height: 14px;
    border-radius: 50px;
    display: inline-block;
    position: absolute;
    left: -50px;
    top: 50%;
    margin-top: -7.5px;
    transition: .5s;
    &[disabled=disabled]{
      cursor:not-allowed;
    }
  }

  .toggle[show=true] .toggle-el{
    transform: translateX(50px);
  }

  .toggle-el label{
    width: 16px;
    height: 16px;
    display: inline-block;
    position: absolute;
    left: 0;
    top: -1px;
    border-radius: 50%;
    transition: .5s;
    cursor:pointer;
    background: #9b9b9b;
    &[disabled=disabled]{
      cursor:not-allowed;
    }
  }

  .toggle-el label[active=true]{
    transform: translateX(16px);
    background: #00913d;
  }

  .toggle-el strong{margin-right: 0;}

  input{
    width: 30px;
    height: 16px;
    opacity: 0;
    position: absolute;
    left: 0;
    top: -1px;
    z-index: 2;
    cursor: pointer;
    &[disabled=disabled]{
      cursor:not-allowed;
    }
  }


  .toggle-actualidad strong{
    font-weight: 600;
    font-size: 14px;
  }

  @media screen and (max-width: 420px){

    .toggle[show=true]{
      padding-left: 36px;
    }

  }


</style>



// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/parts/form/toggle.vue